import { getData, postData } from '@/utils/http'
import config from '@/config'
import moment from "moment";
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],

        //查询条件
        day:moment().format('YYYY-MM-DD'),
        carNo:"",
        searchRule:""
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取驾驶员统计数据列表
        getList({ commit, state }) {
            return new Promise(resolve => {
                getData(`logistics/car/get/mileage/List`, {
                    year:state.day.split("-")[0],
                    month:state.day.split("-")[1],
                    day:state.day.split("-")[2]
                }).then(res => {
                    if (res.state == 1) {
                        var commitData=res.data;
                        //如果有车牌关键词，进行关键词查询
                        if (state.carNo != "") {
                            // 将关键词转为大写，便于不区分大小写匹配
                            const upperKeyword = state.carNo.toUpperCase();
                            // 筛选包含关键词的车辆
                            commitData = res.data.filter(car => {
                                // 获取车辆的车牌号并转为大写
                                const carNo = (car.carNo || '').toUpperCase();
                                // 检查车牌号是否包含关键词
                                return carNo.includes(upperKeyword);
                            });
                        }

                        //如果有查询条件，进行查询
                        var ruleData=commitData;
                        if (state.searchRule != "") {
                            //有运单，没有实际行驶里程
                            if (state.searchRule == "1") {
                                ruleData = commitData.filter(car => {
                                    return car.status!=0&&parseFloat(car.mileage)==0;
                                });
                            }
                            //无运单，有实际行驶里程
                            if (state.searchRule == "2") {
                                ruleData = commitData.filter(car => {
                                    return car.status==0&&parseFloat(car.mileage)>0;
                                });
                            }
                        }


                        commit('CHANGE_TABLE_DATA', ruleData)
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取我的项目列表
        getMyProjectList({ commit, state },deptId) {
            return new Promise(resolve => {
                getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功',
                            data: res.data
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        })
                    }
                })
            })
        },


        //写入当前操作条目
        setActiveItem({ commit }, item) {
            commit('CHANGE_ACTIVE_ITEM', item)
        },

        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit('CHANGE_ADD_LOADING', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}
